export default __webpack_public_path__ + "static/media/betoNoResults.4666cb28.svg";